import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const notificationListView = (data, params) => AxiosService.post(`${apiUrl('event', 'private')}/search?${queryString(params)}`, data);

export const addNotification = (data) => AxiosService.post(`${apiUrl('event', 'private')}/save`, data);

export const updateNotification = (data) => AxiosService.put(`${apiUrl('event', 'private')}/update`, data);

export const activateNotification = (data) => AxiosService.put(`${apiUrl('event', 'private')}/activation?${queryString(data)}`);

export const viewNotification = (data) => AxiosService.get(`${apiUrl('event', 'private')}/view?${queryString(data)}`);

export const deleteNotification = (data) => AxiosService.delete(`${apiUrl('event', 'private')}/delete?${queryString(data)}`);

export const broadcastNotification = (data) => AxiosService.post(`${apiUrl('event', 'private')}/broadcast?${queryString(data)}`);
